import React from 'react'
import './LoadingSpinner.scss'

const LoadingSpinner = ({
  message = 'Cargando...',
  size = 'medium',
  variant = 'primary',
}) => {
  return (
    <div className={`loading-spinner loading-spinner--${size}`}>
      <div
        className={`loading-spinner__spinner loading-spinner__spinner--${variant}`}
      >
        <div className='loading-spinner__circle'></div>
      </div>
      <p
        className={`loading-spinner__message loading-spinner__message--${variant}`}
      >
        {message}
      </p>
    </div>
  )
}

export default LoadingSpinner
